import { render, staticRenderFns } from "./modify-password.vue?vue&type=template&id=79d36a98&scoped=true&"
import script from "./modify-password.vue?vue&type=script&lang=js&"
export * from "./modify-password.vue?vue&type=script&lang=js&"
import style0 from "./modify-password.vue?vue&type=style&index=0&id=79d36a98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d36a98",
  null
  
)

export default component.exports